module.exports = __webpack_public_path__ + "images/help_v2/guide-beginner-9885eb93a615da85d6055765f6a2d915.png";